import Cookies from 'js-cookie';

$(document).ready(function(){
    $('.header-topbar.is-dashboard-bar').on("click", ".close", function(){
        $(this).closest('.header-topbar').slideUp();
        Cookies.set('dashboardBar', 1);
    });
});